import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import type { KbCategoryListItem } from '../types'
import { resolveIcon } from '../utils/iconMap'

interface CategoryGridProps {
    categories: KbCategoryListItem[]
    onSelectCategory: (slug: string) => void
}

const CategoryGrid = ({ categories, onSelectCategory }: CategoryGridProps) => {
    return (
        <section className="kb-categories">
            <div className="kb-categories__header">
                <h2 className="kb-categories__title">Browse by Topic</h2>
                <p className="kb-categories__subtitle">
                    Explore our guides organised by category
                </p>
            </div>
            <div className="kb-categories__grid">
                {categories.map((category, index) => (
                    <button
                        key={category.id}
                        className="kb-category-card"
                        onClick={() => onSelectCategory(category.slug)}
                        style={
                            {
                                '--card-color': category.color,
                                '--card-gradient': category.gradient,
                                '--card-index': index,
                            } as React.CSSProperties
                        }
                    >
                        <div className="kb-category-card__icon-wrapper">
                            <div
                                className="kb-category-card__icon"
                                style={{ background: category.gradient }}
                            >
                                <FontAwesomeIcon
                                    icon={resolveIcon(category.icon)}
                                />
                            </div>
                        </div>
                        <h3 className="kb-category-card__title">
                            {category.title}
                        </h3>
                        <p className="kb-category-card__desc">
                            {category.description}
                        </p>
                        <div className="kb-category-card__footer">
                            <span className="kb-category-card__count">
                                {category.articles_count}{' '}
                                {category.articles_count === 1
                                    ? 'article'
                                    : 'articles'}
                            </span>
                            <span className="kb-category-card__arrow">
                                <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                        </div>
                        <div className="kb-category-card__shine" />
                    </button>
                ))}
            </div>
        </section>
    )
}

export default CategoryGrid
